"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServicePlansEntity_1 = __importDefault(require("./Entity/ServicePlansEntity"));
var ServicePlans_consts_1 = require("./ServicePlans.consts");
var ServicePlansApi = /** @class */ (function () {
    function ServicePlansApi(session) {
        this.servicePlansEntity = new ServicePlansEntity_1.default(session);
    }
    ServicePlansApi.prototype.getAll = function () {
        return this.servicePlansEntity.getAll();
    };
    ServicePlansApi.prototype.get = function (id) {
        return this.servicePlansEntity.service.get(id);
    };
    ServicePlansApi.prototype.create = function (servicePlan) {
        return this.servicePlansEntity.createServicePlan(servicePlan);
    };
    ServicePlansApi.prototype.update = function (id, servicePlan) {
        return this.servicePlansEntity.update(id, servicePlan, ServicePlans_consts_1.updateExtractor, ServicePlans_consts_1.updateExtractor);
    };
    ServicePlansApi.prototype.delete = function (id) {
        return this.servicePlansEntity.deleteServicePlan(id);
    };
    return ServicePlansApi;
}());
exports.default = ServicePlansApi;
//# sourceMappingURL=ServicePlansApi.js.map